import React, {useState} from "react";
import {Card, Col, Row, Select} from "antd";
import PropTypes from 'prop-types';

import DeploymentCreateForm from "../../../components/DeploymentCreateForm";
import SwapDeploymentCreateForm from "../../../components/SwapDeploymentCreateForm";
import {cardsGridColumn} from "../../../assets/styles";

const CarMove = (props) => {
    const [moveAction, setMoveAction] = useState(undefined);

    const onChange = (value) => {
        setMoveAction(value);
    }

    let form = null;
    const {carID} = props;

    switch (moveAction) {
        case 'move':
            form = <DeploymentCreateForm carID={carID}/>
            break;
        case 'swap':
            form = <SwapDeploymentCreateForm carID={carID}/>
            break;
        default:
            break;
    }

    return (
        <Row>
            <Col {...cardsGridColumn}>
                <Card title="Vehicle Moves">
                    <Row className="form-item-label">
                        Move Actions
                    </Row>
                    <Row>
                        <Select onChange={onChange} className="select-in-form">
                            <Select.Option value="move">
                                Move to a new location
                            </Select.Option>
                            <Select.Option value="swap">
                                Swap with another vehicle
                            </Select.Option>
                        </Select>
                    </Row>
                    <Row>
                        {form}
                    </Row>
                </Card>
            </Col>
        </Row>
    )
}

CarMove.propTypes = {
    carID: PropTypes.number.isRequired,
}

export default CarMove;
